import React, { useEffect, useRef } from "react";
import { Col, Row } from "react-bootstrap";
import "./taxfreesummaryofchanges.scss";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
import { addCommas } from "../../helpers/helpers";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../redux/actions";
import NotFound from "../../atoms/NotFound";
import { ERROR } from "../../constants/constants";
import { frequencySuffixMap } from "../../constants/constants";
import dayjs from "dayjs";

const TaxFreeSummaryOfChanges = (props) => {
  const { taxFreeIncomeFetching, taxFreeIncomeData, taxFreeIncomeError } =
    useSelector(
      // eslint-disable-line
      (state) => state.taxFreeIncomeCreateReducer // eslint-disable-line
    );
  const { taxFreeStopFetching, taxFreeStopData } = useSelector(
    (state) => state.taxFreeIncomeStopReducer // eslint-disable-line
  );
  const dispatch = useDispatch();
  const { taxFreeIncomeCreation, taxFreeIncomeStop, taxFreeStopError } =
    bindActionCreators(
      actionCreators,
      dispatch // eslint-disable-line
    );
  const endDate = dayjs().add(1, "day").format("YYYY-MM-DD");
  const payload = props?.newTaxFreeData;
  const popupShown = useRef(false);
  const errorShown = useRef(false);

  const handleContinueClick = () => {
    popupShown.current = true;
    if (payload?.stop) {
      const payloadStop = { endDate };
      taxFreeIncomeStop(props.investorId, props.investorAccountId, payloadStop);
    } else {
      taxFreeIncomeCreation(props.investorId, props.investorAccountId, payload);
    }
  };

  useEffect(() => {
    if (
      !taxFreeIncomeFetching &&
      taxFreeIncomeData?.isSuccess &&
      props.isConfirm !== true &&
      popupShown.current === true
    ) {
      props.handleContinue();
      errorShown.current = false;
    } else if (popupShown.current === true && props.isConfirm !== true) {
      errorShown.current = true;
    }
  }, [taxFreeIncomeFetching, taxFreeIncomeData, taxFreeIncomeError]);

  useEffect(() => {
    if (
      !taxFreeStopFetching &&
      taxFreeStopData?.isSuccess &&
      props.isConfirm !== true &&
      popupShown.current === true
    ) {
      props.handleContinueStop();
      errorShown.current = false;
    } else if (popupShown.current === true && props.isConfirm !== true) {
      errorShown.current = true;
    }
  }, [taxFreeStopFetching, taxFreeStopData, taxFreeStopError]);

  return (
    <div
      className={
        props?.taxFreeData !== undefined
          ? "tf-parent-summary-changes"
          : "tf-parent-confirm"
      }
    >
      <Row>
        <Col>
          <div className="tf-summary-small-close">
            <Link to="">
              <Icons
                iconname="close"
                variant="icon-sixteen-px"
                clickHandler={props.handleCloseButton}
              />
            </Link>
          </div>
        </Col>
      </Row>
      <Row
        className={
          props?.taxFreeData !== undefined
            ? "tf-taxfreeSOCTitle mb-5"
            : "tf-confirm-pop-title mb-2"
        }
      >
        <Col>
          <div>{props.modaltitle}</div>
        </Col>
      </Row>
      {props?.taxFreeData !== undefined ? (
        <>
          <Row className="tf-summary-of-change mb-5 d-none d-xl-block d-lg-block d-md-block">
            <Col>
              <table>
                <thead>
                  <tr>
                    <th className="ps-4">Changes made to</th>
                    <th className="tf-col-pad-allocation">
                      Moving to drawdown per payment
                    </th>
                    <th className="tf-col-pad-total-value">
                      Your tax-free cash income
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="mt-3">
                    <td className="ps-4">
                      <span>{props.taxFreeData.strategyName}</span>
                    </td>
                    <td className="tf-col-pad-allocation">
                      £{addCommas(Math.trunc(props.taxFreeData.perPayment))}.
                      <span className="eac-pot-value-small-digit">
                        {(props.taxFreeData.perPayment % 1)
                          .toFixed(2)
                          .substring(2)}
                      </span>
                      <Icons
                        iconname="arrow-right-fuchsia"
                        variant="icon-sixteen-px"
                      />{" "}
                      {payload?.stop ? (
                        <b>£0.00</b>
                      ) : (
                        <b>
                          £
                          {addCommas(
                            Math.trunc(props.newTaxFreeData.totalAmount) // eslint-disable-line
                          )}
                          .
                          <span className="eac-pot-value-small-digit">
                            {(props.newTaxFreeData.totalAmount % 1)
                              .toFixed(2)
                              .substring(2)}
                          </span>
                        </b>
                      )}
                    </td>
                    <td className="tf-col-pad-total-value">
                      £{addCommas(Math.trunc(props.taxFreeData.taxFreeCash))}.
                      <span className="eac-pot-value-small-digit">
                        {(props.taxFreeData.taxFreeCash % 1)
                          .toFixed(2)
                          .substring(2)}
                      </span>
                      <Icons
                        iconname="arrow-right-fuchsia"
                        variant="icon-sixteen-px"
                      />{" "}
                      {payload?.stop ? (
                        <b>£0.00</b>
                      ) : props.newTaxFreeData.incomeAmount === undefined ||
                        parseFloat(props.newTaxFreeData.incomeAmount) === 0 ||
                        props.newTaxFreeData.incomeAmount === "" ||
                        isNaN(props.newTaxFreeData.incomeAmount) ? (
                        <b>£0.00</b>
                      ) : (
                        <b>
                          £
                          {addCommas(
                            Math.trunc(props.newTaxFreeData.incomeAmount) // eslint-disable-line
                          )}
                          .
                          <span className="eac-pot-value-small-digit">
                            {(props.newTaxFreeData.incomeAmount % 1)
                              .toFixed(2)
                              .substring(2) +
                              " " +
                              frequencySuffixMap[payload?.frequency] || ""}
                          </span>
                        </b>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </Col>
          </Row>
          <Row className="tf-summary-of-change mb-5 d-block d-sm-none">
            <Col>
              <table>
                <thead>
                  <tr>
                    <th className="ps-4">Changes made to</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="mt-3">
                    <td className="ps-4">
                      <div className="tf-mobile-fund-name">
                        {props.taxFreeData.strategyName}
                      </div>
                      <div className="tf-mobile-allocation">
                        <Row>
                          <Col>
                            <span>Allocation</span>
                            <div>
                              <span className="tf-mobile-value">
                                {props.taxFreeData.perPayment}
                              </span>{" "}
                              <Icons
                                iconname="arrow-right-fuchsia"
                                variant="icon-sixteen-px"
                              />{" "}
                              <span className="tf-mobile-percentage-bold">
                                {props.newTaxFreeData.incomeAmount}
                              </span>
                            </div>
                          </Col>
                          <Col>
                            <span>Allocation</span>
                            <div>
                              <span className="tf-mobile-value">
                                {props.taxFreeData.taxFreeCash}
                              </span>{" "}
                              <Icons
                                iconname="arrow-right-fuchsia"
                                variant="icon-sixteen-px"
                              />{" "}
                              <span className="tf-mobile-percentage-bold">
                                {props.newTaxFreeData.totalAmount}
                              </span>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </Col>
          </Row>{" "}
        </>
      ) : (
        <div className="mb-3">
          <div className="tf-confirm-title mb-2">
            We’ve received your request to change your tax-free income.
          </div>
          <div className="tf-confirm-desc">
            Requests received{" "}
            <span className="fw-bold">on or before the 8th</span> will apply to
            the <span className="fw-bold">next payment on the 5th</span>.
            <br />
            Requests received <span className="fw-bold">
              after the 8th
            </span>{" "}
            will apply to the{" "}
            <span className="fw-bold">
              payment on the 5th of the following month
            </span>
            .
            <br />
            <br />
            <span className="fw-bold">For example:</span>
            <br />A request made on <span className="fw-bold">
              5 April
            </span>{" "}
            will apply to the <span className="fw-bold">5 May</span> payment.
            <br />A request made on <span className="fw-bold">
              10 April
            </span>{" "}
            will apply to the <span className="fw-bold">5 June</span> payment.
          </div>
        </div>
      )}
      {props?.taxFreeData !== undefined ? (
        <>
          {payload?.stop ? (
            ""
          ) : (
            <>
              <Row className="text-bottom">
                <Col className="tf-summary-desc mb-3" xl={10} lg={10} md={10}>
                  <div>
                    Changes to drawdown income received on or before the 8th of
                    any month will apply to the payment on 5th of the following
                    month. Changes received after this date will apply from a
                    month later.
                  </div>
                </Col>
              </Row>
              <Row className="text-bottom">
                <Col className="tf-summary-desc mb-4" xl={10} lg={10} md={10}>
                  <div>
                    For example, if a change is received on the 4th of April it
                    would apply from your 5th May payment. A change received on
                    10th April would apply from your 5th June payment.
                  </div>
                </Col>
              </Row>{" "}
            </>
          )}
          <Row className="mb-4">
            <Col>
              <div className="tf-summary-footer-button">
                <div className="tf-tax-free-summary-cancel-button">
                  <Buttons
                    name="Cancel"
                    className="secondary"
                    variantname="icon-sixteen-px"
                    handleClick={props.handleCloseButton}
                  ></Buttons>
                </div>
                <div>
                  <Buttons
                    name="Continue"
                    className="primary"
                    variantname="icon-sixteen-px"
                    handleClick={handleContinueClick}
                  ></Buttons>
                </div>
              </div>
            </Col>
          </Row>{" "}
          {errorShown.current && (
            <NotFound err={ERROR.CLIENT_ERROR} isWarning={false} />
          )}
        </>
      ) : (
        <div className="tf-confirm-button">
          <Buttons
            name="Continue"
            className="primary"
            variantname="icon-sixteen-px"
            handleClick={props.handleContinue}
          ></Buttons>
        </div>
      )}
    </div>
  );
};

export default TaxFreeSummaryOfChanges;
